module.exports = __webpack_public_path__ + "static/img/produce08.7dafba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce08.png
// module id = 138
// module chunks = 4